var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBlueRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9785 7.60506C21.144 7.43952 21.2331 7.21669 21.2331 7.00022C21.2331 6.78375 21.1504 6.56092 20.9785 6.39538L15.5158 0.932736C15.1784 0.595299 14.6372 0.595299 14.2998 0.932736C13.9623 1.27017 13.9623 1.81134 14.2998 2.14878L18.2981 6.14071L0.859629 6.14071C0.382125 6.14071 0.000121773 6.52272 0.000121794 7.00022C0.000121815 7.47772 0.382125 7.85973 0.85963 7.85973L18.2981 7.85973L14.2998 11.858C13.9623 12.1955 13.9623 12.7366 14.2998 13.0741C14.6372 13.4115 15.1784 13.4115 15.5158 13.0741L20.9785 7.60506Z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRightArrow);
export default __webpack_public_path__ + "static/media/BlueRightArrow.e280daff63eed7570c4319ce3a39d603.svg";
export { ForwardRef as ReactComponent };